import { render, staticRenderFns } from "./BalanceText.vue?vue&type=template&id=30429582&"
import script from "./BalanceText.vue?vue&type=script&lang=js&"
export * from "./BalanceText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports